import {
  ButtonBase,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import applePngUrl from "assets/imgs/apple.png";
import playstorePngUrl from "assets/imgs/playstore.png";
import { ReactComponent as XCircleSvg } from "assets/svgs/x-circle.svg";
import clsx from "clsx";
import useToggle from "hooks/useToggle";
import { MediaQueryBreakpointEnum } from "constants/Global";
import "./AvailableForDownload.css";
import AvailableForDownloadContent from "./AvailableForDownloadContent";
import { EnvKeyEnum } from "constants/EnvConstants";

export function AvailableForDownload({ className }) {
  const ismd = useMediaQuery(MediaQueryBreakpointEnum.md);

  const [isDownload, toggleDownload] = useToggle();

  const cancelIconButton = (
    <div className="flex justify-center">
      <IconButton onClick={toggleDownload}>
        <XCircleSvg
          {...(ismd ? { width: 64, height: 64 } : { width: 32, height: 32 })}
        />
      </IconButton>
    </div>
  );

  return (
    <>
      <ButtonBase
        onClick={toggleDownload}
        className={clsx(
          "AvailableForDownload border-white hover:opacity-70",
          className
        )}
      >
        <Typography className="font-bold">DOWNLOAD NOW</Typography>
        {/* <div className='flex-1' /> */}
        {[
          {
            src: applePngUrl,
            to: EnvKeyEnum.GO_DRIVER_APPSTORE_LINK,
          },
          {
            src: playstorePngUrl,
            to: EnvKeyEnum.GO_DRIVER_PLAYSTORE_LINK,
          },
        ].map(({ src, to }, index) => (
          <img key={index} src={src} alt="icon" className="w-8 h-8" />
        ))}
      </ButtonBase>
      {isDownload && (
        <Dialog open fullWidth maxWidth="md" onClose={toggleDownload}>
          <DialogContent className="p-4 md:p-12">
            {!ismd && <div className="mb-4">{cancelIconButton}</div>}
            {<AvailableForDownloadContent />}
            {ismd && cancelIconButton}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}

export function AvailableForDownloadHome({ className }) {
  const ismd = useMediaQuery(MediaQueryBreakpointEnum.md);

  const [isDownload, toggleDownload] = useToggle();

  const cancelIconButton = (
    <div className="flex justify-center">
      <IconButton onClick={toggleDownload}>
        <XCircleSvg
          {...(ismd ? { width: 64, height: 64 } : { width: 32, height: 32 })}
        />
      </IconButton>
    </div>
  );

  return (
    <>
      <ButtonBase
        onClick={toggleDownload}
        className={clsx(
          "AvailableForDownload justify-between border-white hover:opacity-70",
          className
        )}
      >
        <Typography className="font-bold">DOWNLOAD NOW</Typography>

        <div className="flex items-center gap-1">
          {[
            {
              src: applePngUrl,
              to: EnvKeyEnum.GO_DRIVER_APPSTORE_LINK,
            },
            {
              src: playstorePngUrl,
              to: EnvKeyEnum.GO_DRIVER_PLAYSTORE_LINK,
            },
          ].map(({ src, to }, index) => (
            <img key={index} src={src} alt="icon" className="w-8 h-8" />
          ))}
        </div>
      </ButtonBase>
      {isDownload && (
        <Dialog open fullWidth maxWidth="md" onClose={toggleDownload}>
          <DialogContent className="p-4 md:p-12">
            {!ismd && <div className="mb-4">{cancelIconButton}</div>}
            {<AvailableForDownloadContent />}
            {ismd && cancelIconButton}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
